import React from 'react';

import delay from "mn-utils/delay";
import noop from "mn-utils/noop";

import withState from '../../../../utils/withState';
import ButtonBack from "../../../dumb/Button/BackB";
import {backLocation} from "../../../../router";
import Caption from "../../../dumb/Caption/C";
import PrimaryDataDisplay from "./PrimaryDataDisplay";
import SecondaryDataDisplay from "./SecondaryDataDisplay";
import {apiV2TransactionGet} from "../../../../api/admin/transactions";
import toEllipsisMiddle from "../../../../utils/toEllipsisMiddle";

const WrapperWithLoading = require('../../../dumb/WrapperWithLoading/B');

module.exports = withState((setState) => {
  let _id;
  let _cancel = noop;

  const update = () => {
    _cancel();
    _cancel = delay(() => {
      setState({
        loading: true,
      });

      apiV2TransactionGet({
        id: _id,
      }).finally((error, response) => {
        response = response || {};
        setState({
          data: response,
          loading: false,
        });
      }).cancel
    })
  }

  return (state, props) => {
    const params = props.params || {};
    const id = params.id;

    _id !== id && update(_id = id);

    const data = state.data || {};

    return (
      <WrapperWithLoading
        className={'wmin270 wmax1000 ' + (props.className || '')}
        loading={state.loading}
      >
        <div className="layoutRow jcFS aiC fxwWrap dB@m">
          <ButtonBack
            className="m-10 mr24"
            onClick={backLocation}
          />
          <Caption className="fxUnset mr24 mv10@m">
            Transaction details
          </Caption>
          <div className="f23 fw3 lh34 mv10@m">
            {toEllipsisMiddle(data.id, 15)}
          </div>
        </div>
        <PrimaryDataDisplay data={data} />
        <div className="h1 bgDADCE1 mt45 mb45"/>
        <SecondaryDataDisplay data={data}/>
      </WrapperWithLoading>
    )
  }
})